<template>
  <div>
    <h5 class="mb-5">
      Call Technology
    </h5>

    <validation-observer
      ref="formValidation"
      v-slot="{ handleSubmit }"
    >
      <b-form
        novalidate
        @submit.stop.prevent="handleSubmit(onSubmit)"
      >
        <BaseFormRadio
          v-model="details.callTechnology"
          label="Call Technology"
          :options="callTechnologyOptions"
          data-cy="callTechnology"
          stacked
          required
        />

        <BaseFormInput
          v-if="details.callTechnology === 'other'"
          id="otherCallTechnology"
          v-model="otherCallTechnology"
          name="Call Technology Name"
          label="Please specify"
          type="text"
          required
        />

        <BaseFormSelect
          id="accountManager"
          v-model="accountManager"
          name="input-accountManager"
          label="Referred by a sales agent?"
          :options="accountManagersList"
          :disabled="accountManagerId != null"
        />

        <div class="justify-content-center d-flex">
          <BaseButtonLoader
            button-class="custom-button--white-hover-grad pulse mr-3"
            @click="onBack"
          >
            Back
          </BaseButtonLoader>

          <BaseButtonLoader
            button-class="custom-button--white-hover-grad pulse"
            type="submit"
          >
            Next
          </BaseButtonLoader>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'CompanyDetailsForm',

  props: {
    accountManagerId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      details: {
        callTechnology: null,
      },
      accountManager: this.accountManagerId || null,
      otherCallTechnology: null,
      callTechnologyOptions: [
        { text: 'Ringba', value: 'ringba' },
        { text: 'Proprietary', value: 'proprietary' },
        { text: 'Other', value: 'other' }
      ]
    }
  },

  computed: {
    ...mapState('common-entities', ['accountManagers']),

    accountManagersList() {

      const results = this.accountManagers.map(x => {
        return {
          value: x.id,
          text: x.displayName
        }
      })
      
      results.unshift({ text: 'No', value: null })
      return results
    },
  },

  async created () {
    await this.getAccountManagers()
  },

  methods: {
    ...mapActions('registration', ['setCallTechnologyDetails', 'setAccountManager']),
    ...mapActions('common-entities', ['getAccountManagers']),

    onSubmit() {
      this.setCallTechnologyDetails({ callTechnology: this.details.callTechnology === 'other' ? this.otherCallTechnology : this.details.callTechnology })
      this.setAccountManager(this.accountManager)
      this.$emit('submit')
    },

    onBack() {
      this.$emit('back')
    },
  }
}
</script>

<style></style>
